import { render } from "./BubbleRule2.vue?vue&type=template&id=317dfe91&scoped=true"
import script from "./BubbleRule2.vue?vue&type=script&lang=js"
export * from "./BubbleRule2.vue?vue&type=script&lang=js"

import "./BubbleRule2.vue?vue&type=style&index=0&id=317dfe91&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-317dfe91"]])

export default __exports__